<template>
    <section>
      <base-card>
        <h2>Register!</h2>
        <registration-form @save-data="saveData" />
      </base-card>
    </section>
  </template>
    
    <script>
    import RegistrationForm from '../../components/users/RegistrationForm.vue';
    
    export default {
      components: {
          RegistrationForm
      },
      methods: {
      async saveData(data) {
        await this.$store.dispatch('users/registerUser', data);
        this.$router.replace('/user/login')
      }
    }
    };
    </script>
  
  